var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.00104931C6.26848 0.00104931 0 5.3148 0 11.8709C0 15.2046 1.62585 18.2078 4.23507 20.3641C3.66581 23.5215 -0.0120191 24.807 0.239288 25.6758C3.52814 26.9822 10.0414 23.9497 11.0291 23.4796C11.9841 23.6538 12.9838 23.7419 14 23.7419C21.7315 23.7419 28 18.4271 28 11.8709C28 5.3148 21.7304 0.00104931 14 0.00104931Z",
    fill: "#2F7DF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.b55560c2d1141ec0db860334db2716dd.svg";
export { ForwardRef as ReactComponent };